import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

export default autoGeneratedReducer<Record<string, string>>(null);
